/* eslint-disable react-hooks/exhaustive-deps */
import { AnimatePresence, motion } from "motion/react";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import MainPlayer from "@/components/player/MainPlayer";

import FeedRequests from "@/api/feed/feed.requests";
import { EpisodeHistory } from "@/api/feed/feed.types";
import { useGetContentDetailPage } from "@/hooks/api/content.hooks";

const EpisodePage = () => {
  const { id } = useParams() as { id: string };
  const { data } = useGetContentDetailPage(+id);
  const [contentInfo, setContentInfo] = useState<EpisodeHistory>();
  const getData = async () => {
    try {
      const res = await FeedRequests.getEpisodeHistory(+id);
      setContentInfo(res);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  console.log(contentInfo);

  return (
    <AnimatePresence>
      <motion.div
        className="max-h-[100dvh]  w-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 0.5 } }}
        transition={{ duration: 0.5 }}
        style={{ height: "-webkit-fill-available" }}
      >
        <MainPlayer filmId={data?.content?.film?.id} time_code={contentInfo?.time_code || null} />
      </motion.div>
    </AnimatePresence>
  );
};

export default EpisodePage;
